import { useForm } from "react-hook-form";
import axios from "axios";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario.js";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";

function FormEditaCurso(props) {
  const parametros = props.Datos || {};
  const usuario = ObtieneDatosCookies();

  const esEdicion = !!parametros?.id;

  const escuelaInicial =
    typeof parametros === "string"
      ? parametros
      : parametros?.escuela || "";

  const valorInicialPlataforma =
    parametros?.tienePlataforma === "https://cursos.isepsantafe.net.ar"
      ? "si"
      : "no";

  const normalizarFecha = (fecha) => {
    if (!fecha) return "";
    return String(fecha).split("T")[0];
  };

  const [tienePlataforma, setTienePlataforma] = useState(valorInicialPlataforma);
  const [fechaInicio, setFechaInicio] = useState(normalizarFecha(parametros?.fechaInicio));
  const [fechaFinalizacion, setFechaFinalizacion] = useState(
    normalizarFecha(parametros?.fechaFinalizacion)
  );
  const [loading, setLoading] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      escuela: escuelaInicial,
      nombreCurso: parametros?.nombreCurso || "",
      cantDivisiones: parametros?.cantDivisiones || "",
      sede: parametros?.sede || "",
      fechaInicio: normalizarFecha(parametros?.fechaInicio),
      fechaFinalizacion: normalizarFecha(parametros?.fechaFinalizacion),
      estadoCurso: parametros?.estadoCurso || "Activo",
      tienePlataforma: valorInicialPlataforma,
    },
  });

  useEffect(() => {
    reset({
      escuela: escuelaInicial,
      nombreCurso: parametros?.nombreCurso || "",
      cantDivisiones: parametros?.cantDivisiones || "",
      sede: parametros?.sede || "",
      fechaInicio: normalizarFecha(parametros?.fechaInicio),
      fechaFinalizacion: normalizarFecha(parametros?.fechaFinalizacion),
      estadoCurso: parametros?.estadoCurso || "Activo",
      tienePlataforma: valorInicialPlataforma,
    });

    setTienePlataforma(valorInicialPlataforma);
    setFechaInicio(normalizarFecha(parametros?.fechaInicio));
    setFechaFinalizacion(normalizarFecha(parametros?.fechaFinalizacion));
  }, [props.Datos]);

  useEffect(() => {
    setValue("fechaInicio", fechaInicio);

    if (fechaInicio && fechaFinalizacion && fechaFinalizacion < fechaInicio) {
      setFechaFinalizacion(fechaInicio);
      setValue("fechaFinalizacion", fechaInicio);
    }
  }, [fechaInicio]);

  useEffect(() => {
    setValue("fechaFinalizacion", fechaFinalizacion);

    if (fechaInicio && fechaFinalizacion && fechaInicio > fechaFinalizacion) {
      setFechaInicio(fechaFinalizacion);
      setValue("fechaInicio", fechaFinalizacion);
    }
  }, [fechaFinalizacion]);

  const guardarCurso = async (data) => {
    const URI = "https://wwwa.isepsantafe.net.ar/expedientes/";

    const payload = {
      ...data,
      usuarioID: usuario.id,
      sedeID: usuario.sedeID,
      dependenciaID: usuario.destino,
      fechaInicio,
      fechaFinalizacion,
      estadoCurso: esEdicion ? data.estadoCurso : "Activo",
      tienePlataforma:
        tienePlataforma === "si"
          ? "https://cursos.isepsantafe.net.ar"
          : null,
    };

    try {
      setLoading(true);

      if (esEdicion) {
//         console.log(URI + "cursos/actualizaCurso/" + parametros.id, payload)
        await axios.post(URI + "cursos/actualizaCurso/" + parametros.id, payload);

        Swal.fire(
          "Correcto!",
          "El curso fue actualizado correctamente.",
          "success"
        );
      } else {
        await axios.post(URI + "cursos/creaCurso/", payload);

        Swal.fire(
          "Correcto!",
          "El curso fue creado correctamente.",
          "success"
        );
      }

      if (props.onGuardado) {
        props.onGuardado(payload);
      } else if (props.cas) {
        props.cas(payload.escuela);
      }
    }  catch (error) {
  console.error(error);

  let mensaje =
    esEdicion
      ? "Hubo un problema al actualizar el curso."
      : "Hubo un problema al crear el curso.";

  if (error.response?.data?.message) {
    mensaje = error.response.data.message;
  }

  if (error.response?.data?.parent) {
    mensaje += `<br><br><b>Detalle:</b> ${error.response.data.parent}`;
  }

  Swal.fire({
    icon: "error",
    title: "Error",
    html: mensaje,
    confirmButtonText: "Aceptar"
  });
} finally {
      setLoading(false);
    }
  };

  const onSubmit = (data) => {
    data.fechaInicio = fechaInicio;
    data.fechaFinalizacion = fechaFinalizacion;

    Swal.fire({
      title: esEdicion ? "¿Confirmar actualización?" : "¿Confirmar creación?",
      html: `
        <p>Escuela: <strong>${data.escuela || "-"}</strong></p>
        <p>Nombre del Curso: <strong>${data.nombreCurso || "-"}</strong></p>
        <p>Cantidad de Divisiones: <strong>${data.cantDivisiones || "-"}</strong></p>
        <p>Sede: <strong>${data.sede || "-"}</strong></p>
        <p>Fecha Inicio: <strong>${data.fechaInicio || "-"}</strong></p>
        <p>Fecha Finalización: <strong>${data.fechaFinalizacion || "-"}</strong></p>
        <p>Estado: <strong>${esEdicion ? data.estadoCurso : "Activo"}</strong></p>
        <p>Plataforma: <strong>${tienePlataforma === "si" ? "Sí" : "No"}</strong></p>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: esEdicion
        ? "Sí, actualizar curso"
        : "Sí, crear curso",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        guardarCurso(data);
      }
    });
  };

  return (
    <div>
      <form id="asd" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Escuela"
            readOnly
            {...register("escuela", { required: true })}
          />
          <label>Escuela</label>
          {errors.escuela && (
            <span style={{ color: "red" }}>Campo requerido</span>
          )}
        </div>

        <div className="input-group-text">
          <div className="form-floating mb-3" style={{ width: "70%" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre Curso"
              {...register("nombreCurso", {
                required: true,
                minLength: 3,
              })}
            />
            <label>Nombre del Curso</label>
            {errors.nombreCurso && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
          </div>

          <div className="form-floating mb-3" style={{ width: "15%" }}>
            <input
              type="number"
              className="form-control"
              placeholder="Cantidad"
              {...register("cantDivisiones", {
                required: true,
                min: 1,
              })}
            />
            <label>Cant Div</label>
            {errors.cantDivisiones && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
          </div>

          <div
            className="form-floating mb-3"
            style={{ width: "15%", marginTop: "15px" }}
          >
            <select
              className="form-select"
              {...register("sede", { required: true })}
            >
              <option value="">Seleccione</option>

              {usuario.sedeID == 1 && (
                <>
                  <option value="Rosario">Rosario</option>
                  <option value="Recreo">Recreo</option>
                  <option value="Reconquista">Reconquista</option>
                </>
              )}

              {usuario.sedeID == 2 && (
                <option value="Rosario">Rosario</option>
              )}

              {usuario.sedeID == 3 && (
                <option value="Recreo">Recreo</option>
              )}

              {usuario.sedeID == 4 && (
                <option value="Reconquista">Reconquista</option>
              )}
            </select>

            <label>Sede Cursada</label>
            {errors.sede && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
          </div>
        </div>

        <div className="input-group-text">
          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              placeholder="Fecha Inicio"
              {...register("fechaInicio", { required: true })}
              value={fechaInicio}
              max={fechaFinalizacion || ""}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
            <label>Fecha de Inicio</label>
            {errors.fechaInicio && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
          </div>

          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              style={{ width: "240px" }}
              placeholder="Fecha Finalizacion"
              {...register("fechaFinalizacion", { required: true })}
              value={fechaFinalizacion}
              min={fechaInicio || ""}
              onChange={(e) => setFechaFinalizacion(e.target.value)}
            />
            <label>Fecha de Finalización</label>
            {errors.fechaFinalizacion && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
          </div>

          {esEdicion && (
            <div className="form-floating mb-3">
              <select
                className="form-select"
                style={{ width: "160px" }}
                {...register("estadoCurso", { required: true })}
              >
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
              <label>Estado</label>
            </div>
          )}

          <div className="form-floating mb-3">
            <select
              className="form-select"
              style={{ width: "160px" }}
              value={tienePlataforma}
              onChange={(e) => setTienePlataforma(e.target.value)}
            >
              <option value="no">No</option>
              <option value="si">Sí</option>
            </select>
            <label>Plataforma?</label>
          </div>

          <div className="form-floating mb-3" style={{ paddingLeft: "10px" }}>
            <input
              type="submit"
              value={
                loading
                  ? esEdicion
                    ? "Actualizando..."
                    : "Creando..."
                  : esEdicion
                    ? "Actualizar Curso"
                    : "Crear Curso"
              }
              className="btn btn-success"
              disabled={loading}
            />

            <input
              type="button"
              value="Cancelar"
              onClick={() => {
                if (props.onGuardado) {
                  props.onGuardado();
                } else if (props.cas) {
                  props.cas(escuelaInicial);
                }
              }}
              className="btn btn-danger"
              disabled={loading}
              style={{ marginLeft: "5px" }}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default FormEditaCurso;